namespace SP {
    export interface PackageSortingInfo {
        match: boolean;
        package: PackageInfo;
        collectionId: number;
        collections: PackageCollectionInfo[];
        collectionsClosed: PackageCollectionInfo[];
        sortingZone: SortingZoneInfo;
    }
}